import gql from "graphql-tag";

const FORMAUTH_QUERY = gql`
    query GetFormAuth($formId:String!){
    formAuth(id:$formId){
      id
      title
      description
      config{
        protected
        schema
      }
    }
  }
`;
export default FORMAUTH_QUERY;